import { DepartmentExtensionInput, DepartmentInput } from 'generated/graphql-types';
import { DepartmentOption } from '../../extension-register/models/extension-option.interface';

export interface DepartmentExtensionItemView {
   departmentExtensionId: number | null;
   department: DepartmentOption;
   departmentId: number | null;
   extensionId: number | null;
   isDeleted: boolean;
}

export const departmentExtensionKeyFields: (keyof DepartmentExtensionInput)[] = [
   'departmentExtensionId',
   'extensionId',
   'department',
   'departmentId',
];

export const departmentKeyFields: (keyof DepartmentInput)[] = ['departmentId', 'name', 'isActive', 'accountId'];
